// @ts-nocheck
import * as React from "react";

const History: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M11.962 20c-2.03 0-3.8-.663-5.31-1.99-1.51-1.326-2.384-2.996-2.62-5.01h1.01c.273 1.72 1.056 3.15 2.352 4.29C8.689 18.43 10.212 19 11.962 19c1.95 0 3.604-.68 4.962-2.038 1.359-1.358 2.038-3.012 2.038-4.962 0-1.95-.68-3.604-2.038-4.963C15.566 5.68 13.912 5 11.962 5a6.651 6.651 0 0 0-2.917.656 7.782 7.782 0 0 0-2.41 1.806h2.481v1H4.962V4.307h1v2.388A8.309 8.309 0 0 1 8.68 4.712 7.813 7.813 0 0 1 11.962 4c1.109 0 2.148.209 3.118.626.97.417 1.818.988 2.542 1.713a8.066 8.066 0 0 1 1.714 2.543c.417.97.626 2.009.626 3.118a7.805 7.805 0 0 1-.626 3.118 8.066 8.066 0 0 1-1.713 2.542 8.066 8.066 0 0 1-2.543 1.714c-.97.417-2.009.626-3.118.626Zm3.204-4.146-3.646-3.646V7h1v4.792l3.354 3.354-.708.708Z"
            />
        </svg>
    );
};

export default React.memo(History);
